export default __webpack_public_path__ + "static/media/mockups.96d35f42.gif";